// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {ReactNode, useContext, useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import hopt from 'hola_opt';
// @ts-ignore
import {App_context} from '../../../../hola/pub/context';
import {use_scrolled} from '../../../../hola/pub/ui_utils';
import {use_intercom} from '../../../../hola/pub/ui/intercom';
import {i_nav_opt, t_route, t_route_fields} from '../../types/route';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {Settings_context} from '../../../../hola/pub/settings_ctx';

const r_or_call = (v, default_value?)=>{
    if (v===undefined && default_value!==undefined)
        return default_value;
    if (typeof v=='function')
        return v();
    return v;
};

export type use_navbar_props = {
    is_portal?: boolean;
    user_country?: string;
    route?: t_route;
    nav_opt?: i_nav_opt;
    route_opt?: t_route_fields;
}

export const use_navbar = (props: use_navbar_props)=>{
    const {route, user_country, is_portal} = props;
    const geo_blocked = hopt.user_geo_blocked?.blocked;
    // @ts-ignore
    const {is_client, is_plus, user} = useContext(App_context);
    const {y} = use_scrolled();
    const app_route_opt = props.route_opt || {};
    const [opened, set_opened] = useState(false);
    const {app_settings} = useContext(Settings_context);
    const {pathname} = use_pathname();
    const headlogo: boolean = route && r_or_call(route.headlogo,
        app_route_opt.headlogo);
    let headless: boolean = route && r_or_call(route.headless,
        app_route_opt.headless);
    if (app_settings?.meta?.[pathname]?.headless !== undefined)
        headless = app_settings?.meta?.[pathname]?.headless;
    const nomenu: boolean = route && r_or_call(route.nomenu,
        app_route_opt.nomenu);
    const cp_link: string = route && r_or_call(route.cp_link,
        app_route_opt.cp_link);
    const cp_after_login: boolean = route && r_or_call(route.cp_after_login,
        app_route_opt.cp_after_login);
    const cp_always_icon: boolean = route && r_or_call(route.cp_always_icon,
        app_route_opt.cp_always_icon);
    const no_getstarted: boolean = route && r_or_call(route.no_getstarted,
        app_route_opt.no_getstarted);
    const with_cart: boolean = route && r_or_call(route.with_cart,
        app_route_opt.with_cart);
    const nologin: boolean = geo_blocked || route && r_or_call(route.nologin,
        app_route_opt.nologin);
    const nav_opt: i_nav_opt = Object.assign(route && r_or_call(route.nav_opt)
        || {}, props.nav_opt || {});
    const toggle = (state?: boolean)=>{
        if (state === undefined)
            set_opened(v=>!v);
        else
            set_opened(state);
    };
    const intercom = use_intercom();
    useEffect(()=>{
        if (nav_opt?.login_pos!='burger')
            return;
        intercom[opened ? 'hide' : 'show']();
    }, [opened]);
    return {is_client, is_plus, is_scrolled: y > 0, has_user: !!user, opened,
        user_country, headlogo, headless, is_portal, nomenu, nologin,
        nav_opt, toggle, no_getstarted, cp_link, cp_after_login, with_cart,
        cp_always_icon};
};

/* eslint-disable */
export enum NAVBAR_SLOTS {
    mobile_left = 'mobile_left',
    mobile_mid = 'mobile_mid',
    mobile_right = 'mobile_right',
}
/* eslint-enable */

interface i_navbar_portal_props {
    slot: NAVBAR_SLOTS;
    children: ReactNode;
}

export const Navbar_portal = ({slot, children}: i_navbar_portal_props)=>{
    const slot_el = document.querySelector(`*[data-slot=${slot}]`);
    return slot && slot_el ? createPortal(children, slot_el) : null;
};
